var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3369,
    height: 3369,
    viewBox: "0 0 3369 3369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1684.5,
    cy: 1684.5,
    r: 202.815,
    stroke: "#7A709B",
    strokeOpacity: 0.37,
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1684.5,
    cy: 1684.5,
    r: 339.916,
    stroke: "#7A709B",
    strokeOpacity: 0.37,
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1684.5,
    cy: 1684.5,
    r: 518.816,
    stroke: "#7A709B",
    strokeOpacity: 0.37,
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1684.5,
    cy: 1684.5,
    r: 813.081,
    stroke: "#7A709B",
    strokeOpacity: 0.37,
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1684.5,
    cy: 1684.5,
    r: 1202.65,
    stroke: "#7A709B",
    strokeOpacity: 0.37,
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1684.5,
    cy: 1684.5,
    r: 1682.5,
    stroke: "#7A709B",
    strokeOpacity: 0.37,
    strokeWidth: 4,
    strokeDasharray: "2 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.dc0e04b191613d6e2f9cd78625fe740b.svg";
export { ForwardRef as ReactComponent };